import { render, staticRenderFns } from "./ReleaseNoteModal.vue?vue&type=template&id=39e10bd5&scoped=true&"
import script from "./ReleaseNoteModal.vue?vue&type=script&lang=js&"
export * from "./ReleaseNoteModal.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseNoteModal.vue?vue&type=style&index=0&id=39e10bd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e10bd5",
  null
  
)

export default component.exports